export enum OperationTypeModel {
	Multiplication = 1,
	Division = 2,
	SetQuantity = 3
}
